module.exports = __webpack_public_path__ + "img/product12.7a7ac4e5.png";